import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  forwardRef,
  OnChanges,
  SimpleChanges,
  QueryList,
  ViewChildren,
  NgZone
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

/**
 * Logger Factory
 * @namespace value: current value of input
 * @namespace items: list of items to show (arrive from the parent)
 * @namespace errorMessage: message to show in case of error
 * @namespace isValidCode: if true, the code is valid and can we go ahead otherwise show errorMessage
 * @namespace changeValue: is the value after have been changed
 * ES:
 *  <ute-input-square [items]="items"
 *                   [isValidCode]="isValidCode"
 *                   (changeValue)="test($event)"
 *                   errorMessage="Nessun gruppo associato a questo codice">
 *  </ute-input-square>
 */

@Component({
  selector: "ute-input-square",
  templateUrl: "ute-input-square.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UteInputSquareComponent),
      multi: true
    }
  ]
})
export class UteInputSquareComponent
  implements OnInit, ControlValueAccessor, OnChanges {
  @ViewChildren("inp") inps: QueryList<any>;
  @Input() errorMessage: string;
  @Input() isValidCode: boolean = true;
  @Input() isDisabled: boolean = false;
  @Input() extValue: any[] = [
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" }
  ];
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeCodeValue = new EventEmitter();

  // @Output() codeWrited: boolean = false;

  public value: string = "";
  public innerValue: any[];
  private propagateChange = (_: any) => {};
  private propagateTouch = () => {};

  codeWrited: boolean = false;

  constructor(public zone: NgZone) {
    this.innerValue = [
      { value: "" },
      { value: "" },
      { value: "" },
      { value: "" }
    ];
  }

  ngOnInit() {}

  checkInsertCode(event) {
    this.zone.run(() => {
      this.changeCodeValue.emit(true);
    });
  }

  changeValue(event) {}

  keypressed(i, event) {
    this.zone.run(() => {
      const currentCode = event.which || event.code;
      let currentKey = event.key;
      if (!currentKey || currentKey == "Unidentified") {
        currentKey = event.target.value;
      }

      const els = this.inps.toArray();
      this.isValidCode = true;
      //console.log("key: >",event.key,"<")
      const regex = /^[a-zA-Z0-9]{1}$/;
      const next = i + 1;
      const prev = i - 1;

      if (currentKey === "Backspace") {
        // remove the current or go back

        if (this.innerValue[i].value !== "") {
          // case if is not empty
          this.innerValue[i].value = ""; // delete the current value
          this.extValue[i].value = ""; // delete the html value
          els[i].setFocus(); // set the current with focus
        } else {
          // case if is empty
          if (i !== 0) {
            // if isn't the first
            els[prev].setFocus(); // set the previous with focus
          }
        }
        this.codeWrited = false;
        this.changeCodeValue.emit(false);
      } else if (currentKey === "Delete") {
      } else if (currentKey === "ArrowRight" || currentKey === " ") {
        // case when go right
        if (currentKey === " ") {
          if (this.innerValue[i].value == " ") {
            this.innerValue[i].value = "";
          }
          if (this.extValue[i].value == " ") {
            this.extValue[i].value = "";
          }
        }
        if (next < 4) {
          els[next].setFocus();
        }
      } else if (currentKey === "ArrowLeft") {
        // case when go left
        if (prev >= 0) {
          els[prev].setFocus();
        }
      } else if (regex.test(currentKey)) {
        // case if is a letter or number
        this.innerValue[i].value = "" + currentKey; // set the new value
        this.extValue[i].value = "" + currentKey; // set the html value

        if (next < 4) {
          // set the focus to the next
          els[next].setFocus();
        }
      }

      // after all

      // propagate the value
      const arr = this.innerValue.map(e => e);
      this.value = `${arr[0].value}${arr[1].value}${arr[2].value}${arr[3].value}`;
      this.propagateChange(this.value);

      // check if is full filled
      if (
        this.innerValue[0].value !== "" &&
        this.innerValue[1].value !== "" &&
        this.innerValue[2].value !== "" &&
        this.innerValue[3].value !== ""
      ) {
        // enable the confirm
        this.codeWrited = true;
        this.changeCodeValue.emit(true);
      } else {
        // disable the confirm
        this.codeWrited = false;
        this.changeCodeValue.emit(false);
      }
    });
  }

  /* onInput(next, event) {
    const els = this.inps.toArray();
    if (next < 4) {
      els[next].setFocus();
      this.codeWrited = false;
      this.changeCodeValue.emit(false);
    }

    if (next == 4) {
      this.codeWrited = true;
      this.changeCodeValue.emit(true);
    }
  } */

  onBlur(event) {
    this.zone.run(() => {
      this.propagateTouch();
      this.blur.emit(event);
    });
  }

  public writeValue(obj: any) {
    this.zone.run(() => {
      if (obj) {
        this.value = obj;
      }
    });
  }

  public registerOnChange(fn: any) {
    this.zone.run(() => {
      this.propagateChange = fn;
    });
  }

  public registerOnTouched(fn: any) {
    this.zone.run(() => {
      this.propagateTouch = fn;
    });
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    this.zone.run(() => {
      if (simpleChange.isValidCode && simpleChange.isValidCode.currentValue) {
        this.isValidCode = simpleChange.isValidCode.currentValue;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-input-square/ute-input-square.component.ts